export default class EnumTypes {

  static getProjectStatusName(projectStatus: string) {
    switch (projectStatus) {
      case 'Pending Revision':
        return 'En construcción';
      case 'Funding Process':
        return 'En financiación';
      case 'Formalization Process':
        return 'Formalizando operación';
      case 'Successfully Funded':
        return 'Financiado con éxito';
      case 'Funding Failed':
        return 'Financiación inalcanzada';
      case 'Due Diligence Not Passed':
        return 'Due Diligence no superada';
      case 'Formalization Failed':
        return 'Formalización fallida';
      default:
        return 'En construcción';
    }
  }

  static getProjectFormalizationStatusName(projectFormalizationStatus: string) {
    switch (projectFormalizationStatus) {
      case 'Writing Contracts':
        return 'Redactando contratos';
      case 'Reviewing Contracts':
        return 'Revisando contratos';
      case 'Signing Contracts':
        return 'Firmando contratos';
      default:
        return 'Redactando contratos';
    }
  }

  static getProjectDueDiligenceStatusName(projectDueDiligenceStatus?: string) {
    switch (projectDueDiligenceStatus) {
      case 'No':
        return 'No';
      case 'In Progress':
        return 'En Proceso';
      case 'Yes':
        return 'Sí';
      default:
        return 'No';
    }
  }

  static getMaritalStatusName(maritalStatus?: string) {
    switch (maritalStatus) {
      case 'Single':
        return 'Soltero/a';
      case 'Married':
        return 'Casado/a';
      case 'Widower/widow':
        return 'Viudo/a';
      case 'Divorced':
        return 'Divorciado/a';
      default:
        return 'Soltero/a';
    }
  }

  static returnMaritalStatusName(maritalStatus?: string) {
    switch (maritalStatus) {
      case 'Soltero/a':
        return 'Single';
      case 'Casado/a':
        return 'Married';
      case 'Viudo/a':
        return 'Widower/widow';
      case 'Divorciado/a':
        return 'Divorced';
      default:
        return 'Single';
    }
  }

  static getMaritalEconomicStatusName(maritalEconomicStatus?: string) {
    switch (maritalEconomicStatus) {
      case 'Separation of Property Regime':
        return 'Régimen de separación de bienes';
      case 'Participation Regime':
        return 'Régimen de participación';
      case 'Profit Regime':
        return 'Régimen de gananciales';
      default:
        return 'Régimen de separación de bienes';
    }
  }

  static returnMaritalEconomicStatusName(maritalEconomicStatus?: string) {
    switch (maritalEconomicStatus) {
      case 'Régimen de separación de bienes':
        return 'Separation of Property Regime';
      case 'Régimen de participación':
        return 'Participation Regime';
      case 'Régimen de gananciales':
        return 'Profit Regime';
      default:
        return 'Separation of Property Regime';
    }
  }

  static getMaritalPropertyRegimeName(maritalPropertyStatus?: string) {
    switch (maritalPropertyStatus) {
      case 'Matrimonial Assets':
        return 'Gananciales';
      case 'Privative':
        return 'Privativos';
      case 'Pre-nuptial Agreements':
        return 'Con capitulaciones';
      default:
        return 'Gananciales';
    }
  }

  static returnMaritalPropertyRegimeName(maritalPropertyStatus?: string) {
    switch (maritalPropertyStatus) {
      case 'Gananciales':
        return 'Matrimonial Assets';
      case 'Privativos':
        return 'Privative';
      case 'Con capitulaciones':
        return 'Pre-nuptial Agreements';
      default:
        return 'Matrimonial Assets';
    }
  }

  static getOccupationTypesName(occupationType?: string) {
    switch (occupationType) {
      case 'Paid Employment':
        return 'Trabajador por cuenta ajena';
      case 'Self-Employment':
        return 'Trabajador por cuenta propia';
      case 'Student':
        return 'Estudiante';
      case 'Retired':
        return 'Jubilado';
      case 'Other':
        return 'Otro';
      default:
        return 'Trabajador por cuenta ajena';
    }
  }

  static returnOccupationTypesName(occupationType?: string) {
    switch (occupationType) {
      case 'Trabajador por cuenta ajena':
        return 'Paid Employment';
      case 'Trabajador por cuenta propia':
        return 'Self-Employment';
      case 'Estudiante':
        return 'Student';
      case 'Jubilado':
        return 'Retired';
      case 'Otro':
        return 'Other';
      default:
        return 'Paid Employment';
    }
  }

  static getInvestorTypeName(investorType?: string) {
    switch (investorType) {
      case 'No Accredited':
        return 'No acreditado';
      case 'Accredited':
        return 'Acreditado';
      default:
        return 'No acreditado';
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/EnumStates/EnumTypes.tsx